<template>
  <nav v-if="$store.getters['user/isLogged'] && $route.path!='/print'">
    <v-navigation-drawer v-model="drawer" class="secondary" disable-resize-watcher app>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="display-2">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="$store.getters['user/domain']"></v-list-item-title>
            <v-list-item-subtitle
              v-text="$store.getters['user/userinfo'] || $store.getters['user/name']"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-5"></v-divider>
        <v-checkbox v-model="hideText" :label="$t('label.hidetext')" class="ml-4"></v-checkbox>
        <v-divider class="mb-5"></v-divider>
        <v-list-item-group>
          <template v-for="item in upperMenu">
            <v-list-item
              v-if="$store.getters.test(item.rule)"
              link
              :key="item.text"
              class="hidden-lg-and-up"
              :to="item.route"
            >
              <v-list-item-icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('menu.'+item.text)}}</v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item icon to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <i18n path="help.menu.home" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.getters.test('actlog')" icon to="/activity">
            <v-list-item-icon>
              <v-icon>mdi-notebook-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.actlog')}}</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$store.getters.test('utils')" icon to="/admin">
            <v-list-item-icon>
              <v-icon>mdi-tools</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.tools')}}</v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$store.getters.test('tickets.u') || $store.getters.test('tickets.a')"
            icon
            to="/tickets"
          >
            <v-list-item-icon>
              <v-icon>mdi-sync-alert</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.tickets')}}</v-list-item-content>
          </v-list-item>
          <v-list-item @click="logoff">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{$t('menu.logout')}}</v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider class="mb-5"></v-divider>
      <SelectLocale />
      <div class="my-2" v-if="$store.getters.test('fmode.s')">
        <v-divider class="mb-5"></v-divider>
        <v-radio-group v-model="mode" @change="change">
          <template v-for="(k,i) in $t('admin.interface_type')">
            <v-radio :label="k" :value="i" :key="i" class="ml-4"></v-radio>
          </template>
          <!--          <v-radio label="Admin" :value="0"></v-radio>
          <v-radio label="Gift card" :value="1"></v-radio>
          <v-radio label="Client accumulation (Sjuzanna)" :value="2"></v-radio>
          <v-radio label="Client accumulation (Gards)" :value="3"></v-radio>
          <v-radio label="Reversу сlient accumulation" :value="4"></v-radio>!-->
        </v-radio-group>
      </div>
    </v-navigation-drawer>

    <v-app-bar v-if="$store.getters['user/isLogged'] && $route.path!='/print'" app class="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-only">{{$t('menu.title')}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-for="item in upperMenu">
        <v-tooltip bottom :key="item.text">
          <template #activator="{on}">
            <v-btn
              v-on="on"
              v-if="$store.getters.test(item.rule)"
              v-show="$store.getters['user/isLogged'] || item.open"
              text
              class="ml-2"
              :to="item.route"
            >
              <v-icon :small="item.small" class="mr-3">{{ item.icon }}</v-icon>
              <i18n
                v-if="$vuetify.breakpoint.lgAndUp && !hideText"
                :path="'menu.'+item.text"
                class="menu-text"
              />
            </v-btn>
          </template>
          <i18n :path="'menu.'+item.text" />
        </v-tooltip>
      </template>
      <v-btn v-if="$store.getters.test('utils')" icon to="/admin">
        <v-icon>mdi-tools</v-icon>
      </v-btn>
      <v-btn icon to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>
  </nav>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
import SelectLocale from "@/components/Select-locale";

export default {
  components: { SelectLocale },
  name: "AppHeader",
  data() {
    return {
      hideText: false,
      mode: this.$store.getters.iface,
      title: this.$t("title.main"),
      drawer: false,
      upperMenu: app.upper_menu,
    };
  },
  computed: {},
  mounted() {
    this.$root.$on("SetHeaderTitle", (arg1) => {
      this.title = arg1;
    });
  },

  methods: {
    change() {
      this.$store.commit("setIface", this.mode);
    },
    logoff() {
      this.$store.dispatch("user/LOGOUT").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
<style scoped>
.menu-text {
  font-size: small;
}
</style>
